export default __webpack_public_path__ + "static/media/structure-well.fc525310.svg";